import React from "react";
import { Container, Row, Col, FormGroup, Button } from 'reactstrap';
import writeXlsxFile from 'write-excel-file';
import DatePicker from "../Form/DatePicker";
import { FormLabel } from "../Form/FormLabel";
import { useState, useEffect } from "react";
import LoadingAnimation from "../Form/LoadingAnimation";
import useFetchSimple from '../../Services/useFetchSimple';
import { endpoints } from "../../utils/Constants";

const PayLoadReportExport = () => {
    const thisQuarter = parseInt((new Date().getMonth() + 1) / 3);
    const year = thisQuarter === 0 ? new Date().getFullYear() - 1 : new Date().getFullYear();
    const lastQuarter = thisQuarter === 0 ? 4 : thisQuarter - 1;
    const fromDate = new Date(year, (lastQuarter * 3) - 1, 1);
    const toDate = new Date(year, lastQuarter * 3 + 2, 1);
    const [fromDateSelected, setFrom] = useState(fromDate);
    const [toDateSelected, setTo] = useState(toDate);
    const [reportDetails, setReportDetails] = useState();
    const [initialReportDetails, setInitialReportDetails] = useState();
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const fetch = useFetchSimple();

    const handleChangeFrom = (e) => {
        setFrom(e);
        if (!initialReportDetails) return;
        setReportDetails(initialReportDetails.filter(book => new Date(book.departureTimeToFilter).getTime() >= e &&
            new Date(book.departureTimeToFilter).getTime() <= toDateSelected));
    };
    const handleChangeTo = (e) => {
        setTo(e);
        if (!initialReportDetails) return;
        setReportDetails(initialReportDetails.filter(book => new Date(book.departureTimeToFilter).getTime() >= fromDateSelected &&
            new Date(book.departureTimeToFilter).getTime() <= e));
    };

    useEffect(() => {
        fetch(endpoints.payloadReport)
            .then(res => res)
            .then(result => {
                setReportDetails(result.body);
                setInitialReportDetails(result.body);
                setLoading(false);
            }, err => {
                setError(err);
                setLoading(false);
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const buildRows = () => {
        if (!reportDetails) return [];
        return reportDetails.map(detail => ({
            Job: 'JB' + detail.jobReference,
            DepartureTime: detail.departureTime,
            Operator: detail.operator,
            Aircraft: detail.aircraft,
            Route: detail.route,
            TotalSeats: detail.totalSeats,
            SeatsBooked: detail.seatsBooked,
            SeatsAvailable: (detail.totalSeats - detail.seatsBooked),
            EstimatedMaxPayload: detail.maxPayLoad,
            PayloadUsed: detail.payLoadUsed,
            PayloadAvailable: (detail.maxPayLoad - detail.payLoadUsed),
            ClientDepartment: detail.clientDepartment
        }));
    };

    const schema = [
        { column: 'Job', type: String, value: r => r.Job },
        { column: 'Departure Time', type: String, value: r => r.DepartureTime },
        { column: 'Operator', type: String, value: r => r.Operator },
        { column: 'Aircraft', type: String, value: r => r.Aircraft },
        { column: 'Route', type: String, value: r => r.Route },
        { column: 'Total Seats', type: Number, value: r => r.TotalSeats },
        { column: 'Seats Booked', type: Number, value: r => r.SeatsBooked },
        { column: 'Seats Available', type: Number, value: r => r.SeatsAvailable },
        { column: 'Estimated Max Payload', type: Number, value: r => r.EstimatedMaxPayload },
        { column: 'Payload Used', type: Number, value: r => r.PayloadUsed },
        { column: 'Payload Available', type: Number, value: r => r.PayloadAvailable },
        { column: 'Client Department', type: String, value: r => r.ClientDepartment }
    ];

    const download = async () => {
        const rows = buildRows();
        if (!rows.length) return;
        await writeXlsxFile(rows, { schema, fileName: 'payload-report.xlsx' });
    };

    return <Container>
        <Row style={{ height: 320 }}>
            <Col>
                <FormGroup>
                    <FormLabel>From</FormLabel>
                    <DatePicker disabled={loading} type='datetime-local' placeholder="Report From" onChange={handleChangeFrom} selected={fromDateSelected} />
                </FormGroup>
            </Col>
            <Col>
                <FormGroup>
                    <FormLabel>To</FormLabel>
                    <DatePicker disabled={loading} type='datetime-local' placeholder="Report To" onChange={handleChangeTo} selected={toDateSelected} />
                </FormGroup>
            </Col>
        </Row>
        {loading ? <LoadingAnimation /> : null}
        {error ? <h5>Error Loading Report</h5> : null}
        <Row className="align-items-center">
            <Col style={{ textAlign: "center" }}>
                {reportDetails ? <Button type='button' onClick={download}>Download Data</Button> : null}
            </Col>
        </Row>
    </Container>;
};

export default PayLoadReportExport;